<template>
  <div class="fleet-task-multi-fo">
    <b-dropdown
      ref="foDropdown"
      variant="link"
      toggle-class="fleet-task-multi-fo__toggle"
      menu-class="fleet-task-multi-fo__menu"
      no-caret
      @show="handleDropdownShow"
      @hidden="handleDropdownHidden"
    >
      <template #button-content>
        <span class="fleet-task-multi-fo__toggle-text text-secondary-route-link">
          Multi FO ({{ foList.length }})
        </span>
      </template>

      <div class="fleet-task-multi-fo__list">
        <div
          v-for="(fo, idx) in foList"
          :key="fo.id || idx"
          class="fleet-task-multi-fo__item dropdown-item"
        >
          <router-link
            :to="{ name: 'Fleet Task Detail', params: { id: fo.fleet_task.id } }"
            class="fleet-task-multi-fo__item-link"
            @click.native="$refs.foDropdown.hide()"
          >
            <span class="fleet-task-multi-fo__item-text text-secondary-route-link">{{ fo.fleet_task.number }}</span>
          </router-link>
        </div>
      </div>
    </b-dropdown>
  </div>
</template>

<script>
export default {
  name: 'FleetTaskMultiFoDropdown',
  props: {
    detail: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      isDropdownOpen: false,
    }
  },
  computed: {
    foList() {
      return this.detail?.transits || []
    },
  },
  methods: {
    handleDropdownShow() {
      this.isDropdownOpen = true
    },
    handleDropdownHidden() {
      this.isDropdownOpen = false
    },
  },
}
</script>

<style lang="scss" scoped>
.fleet-task-multi-fo {
  display: inline-flex;
  align-items: center;

  &__toggle {
    background: transparent !important;
    border: none !important;
    padding: 0 !important;
    display: inline !important;
    cursor: pointer;
    color: inherit !important;
    font-weight: inherit !important;
    font-size: inherit !important;
    line-height: inherit !important;
    box-shadow: none !important;
    outline: none !important;
    text-decoration: none !important;
    vertical-align: baseline !important;

    &:hover {
      text-decoration: none !important;
      opacity: 0.85;
    }

    &:focus,
    &:active,
    &.show,
    &:focus-visible {
      background: transparent !important;
      border: none !important;
      box-shadow: none !important;
      outline: none !important;
      text-decoration: none !important;
    }

    &::after {
      display: none !important;
    }
  }

  &__list {
    max-height: 100px;
    overflow-y: auto;

    &::-webkit-scrollbar {
      width: 6px;
    }

    &::-webkit-scrollbar-thumb {
      background-color: #c1c5d0;
      border-radius: 3px;
    }

    &::-webkit-scrollbar-track {
      background-color: transparent;
    }
  }

  &__item {
    min-height: 32px;
    display: flex !important;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #e6e7ec;
    cursor: pointer;
    transition: background-color 0.15s ease;
    width: 100%;
    text-align: left;
    padding: 0 !important;
    margin: 0 !important;
    clear: both;

    &:last-child {
      border-bottom: none;
    }

    &:hover {
      background-color: #f2f4f7 !important;
    }

    &:focus,
    &:active {
      background-color: transparent !important;
      outline: none !important;
    }

    &.dropdown-item {
      padding: 0 !important;
      white-space: normal;
    }
  }

  &__item-link {
    display: flex;
    align-items: center;
    width: 100%;
    min-height: 32px;
    padding: 0 0.75rem;
    text-decoration: none !important;
    color: inherit;

    &:hover {
      text-decoration: none !important;
    }

    &:focus {
      outline: none !important;
    }
  }

  &__item-text {
    font-size: 12px;
    font-weight: 500;
    line-height: 20px;
    transition: text-decoration 0.15s ease;
  }

  &__item-arrow {
    font-size: 14px;
    color: #384157;
    opacity: 0.6;
  }
}
</style>

<style lang="scss">
.fleet-task-multi-fo__menu {
  min-width: 120px !important;
  max-width: 120px !important;
  padding: 4px 0 !important;
  border: 1px solid #e6e7ec !important;
  border-radius: 5px !important;
  box-shadow: 0 8px 24px rgba(52, 66, 100, 0.12) !important;
  transform: translateX(40px) !important;
}

.fleet-task-multi-fo__toggle.dropdown-toggle.btn.btn-secondary,
.fleet-task-multi-fo__toggle.dropdown-toggle.btn.btn-link {
  background: transparent !important;
  border: none !important;
  padding: 0 !important;
  color: inherit !important;
  font-weight: inherit !important;
  font-size: inherit !important;
  line-height: inherit !important;
  box-shadow: none !important;
  border-radius: 0 !important;
  text-decoration: none !important;

  &:hover {
    text-decoration: none !important;
  }
}
</style>
